module.exports = __webpack_public_path__ + "static/media/papers.d6dfed47.jpg";